import React from "react";
import { NavLink } from "react-router-dom";
import { Boxes, Map, User, LayoutDashboard, ShoppingBag, ShieldCheck, Package, Calculator, Truck } from "lucide-react";
import { useAuth } from "../hooks/useAuth";

export default function Menu() {
  const { user } = useAuth();

  // Common visual styles for links
  const linkClasses = ({ isActive }) =>
    `relative flex items-center lg:justify-center justify-start gap-3 p-3 rounded-2xl transition-all duration-300 group w-full lg:w-auto
     ${
       isActive
         ? "bg-gradient-to-r from-red-700 to-red-600 text-yellow-50 shadow-lg shadow-red-500/30 scale-100 border border-yellow-500/30"
         : "text-gray-600 dark:text-gray-400 hover:bg-red-50 dark:hover:bg-red-900/20 hover:text-red-700 dark:hover:text-red-400 hover:shadow-md hover:border-red-200"
     }`;

  const Tooltip = ({ text }) => (
     <span className="absolute left-[calc(100%+10px)] top-1/2 -translate-y-1/2 px-3 py-1.5 bg-gradient-to-r from-red-800 to-red-900 border border-yellow-500/40 text-yellow-50 text-xs font-medium rounded-lg opacity-0 group-hover:opacity-100 transition-all duration-300 whitespace-nowrap z-[100] pointer-events-none shadow-xl shadow-red-900/40 hidden lg:block backdrop-blur-sm -translate-x-2 group-hover:translate-x-0">
        {text}
        {/* Tiny triangle pointing left */}
        <span className="absolute top-1/2 -left-1 -translate-y-1/2 border-t-[4px] border-t-transparent border-r-[4px] border-r-red-800 border-b-[4px] border-b-transparent"></span>
     </span>
  );

  const Label = ({ text }) => (
      <span className="block lg:hidden text-sm font-medium">{text}</span>
  );

  return (
    <nav className="flex flex-col gap-3 w-full">
      <NavLink to="/dashboard/online" end className={linkClasses}>
        <LayoutDashboard size={20} />
        <Label text="Tổng quát" />
        <Tooltip text="Tổng quát" />
      </NavLink>

      <NavLink to="/dashboard/online/tiktok" className={linkClasses}>
        <div className="relative">
             <ShoppingBag size={20} />
             <span className="absolute -bottom-1 -right-1 text-[8px] font-bold">TK</span>
        </div>
        <Label text="Kênh TikTok" />
        <Tooltip text="Kênh TikTok" />
      </NavLink>

      <NavLink to="/dashboard/online/shopee" className={linkClasses}>
        <div className="relative">
             <ShoppingBag size={20} />
             <span className="absolute -bottom-1 -right-1 text-[8px] font-bold">SP</span>
        </div>
        <Label text="Kênh Shopee" />
        <Tooltip text="Kênh Shopee" />
      </NavLink>

      <div className="h-px bg-gray-200 my-1 mx-2"></div>

      <NavLink to="/dashboard/online/products" className={linkClasses}>
        <Package size={20} />
        <Label text="Phân tích Sản phẩm" />
        <Tooltip text="Phân tích Sản phẩm" />
      </NavLink>

      <NavLink to="/dashboard/online/inventory" className={linkClasses}>
        <Boxes size={20} />
        <Label text="Tồn kho" />
        <Tooltip text="Tồn kho" />
      </NavLink>

      <NavLink to="/dashboard/online/location" className={linkClasses}>
        <Map size={20} />
        <Label text="Tỉnh thành" />
        <Tooltip text="Tỉnh thành" />
      </NavLink>

      <NavLink to="/dashboard/online/customers" className={linkClasses}>
        <User size={20} />
        <Label text="Khách hàng" />
        <Tooltip text="Khách hàng" />
      </NavLink>

      <div className="h-px bg-gray-200 my-1 mx-2"></div>

      <NavLink to="/dashboard/online/tools/deal-calculator" className={linkClasses}>
        <div className="relative">
             <Calculator size={20} />
        </div>
        <Label text="Tính Deal" />
        <Tooltip text="Tính Deal" />
      </NavLink>
      
      <NavLink to="/dashboard/online/tools/compensation-order" className={linkClasses}>
        <Truck size={20} />
        <Label text="Tạo Đơn Bù" />
        <Tooltip text="Tạo Đơn Bù" />
      </NavLink>
      

      
      {/* Admin Only Link */}
      {user?.role === 'admin' && (
        <React.Fragment>
          <div className="h-px bg-gray-200 my-1 mx-2"></div>
          <NavLink to="/dashboard/online/admin/users" className={linkClasses}>
             <ShieldCheck size={20} />
             <Label text="Admin Users" />
             <Tooltip text="Admin Users" />
          </NavLink>
        </React.Fragment>
      )}
    </nav>
  );
}
